import { useGetReviewCount } from "../../../../aiReview/apis/useGetReviewCount";
import { ModeratorRoutesPrivileges } from "../../../constants";
import { useHasPrivilege } from "../../useHasPrivilege";

/**
 * Sidebar badge for the "To review" route: the open items of
 * `GET /admin/ai-review/count`. There is no socket for review items, so the
 * count polls (AI_REVIEW.COUNT_POLL_MS); handling an item on the page, or
 * saving a lesson from the correction panel, refreshes it at once.
 */
export const useAiReviewCounter = () => {
  const canAccess = useHasPrivilege(ModeratorRoutesPrivileges.AiAssistants);
  const { data } = useGetReviewCount({ enabled: canAccess });

  return { aiReviewCount: data?.open ?? 0 };
};
